import { biText } from '@euler/app/components/message/widgets/bi-visualization/functions/biText';
import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDatasetAccess } from '@euler/model/bi/dataset';
import { BiDatasetDetail } from '@euler/model/bi/library';
import { BiDatasetRefKind } from '@euler/model/bi/query';
import { memo } from 'react';
import { View } from 'react-native';
import { biTimeLabel } from '../../functions/biDashboardText';
import { DetailSection } from './DetailSection';
import { FactRow } from './FactRow';

/** What the dataset is, where it came from, who may do what with it. */
export const DatasetFacts = memo(({ detail }: { detail: BiDatasetDetail }) => {
  const { rpx } = useResponsiveContext();
  const description = biText(detail.catalog.description);
  if (detail.kind === BiDatasetRefKind.Sql)
    return (
      <DetailSection title="说明">
        <CardNotice text={description || '门店系统里的业务数据。'} />
        <FactRow label="类型" value="内置数据，只读" />
        <FactRow
          label="字段"
          value={`你的角色可以用 ${detail.catalog.fields.length} 个字段`}
        />
      </DetailSection>
    );
  const { dataset } = detail;
  const source = [
    dataset.sourceFileName,
    dataset.sourceSheet ? `工作表「${dataset.sourceSheet}」` : null,
  ]
    .filter(Boolean)
    .join(' · ');
  return (
    <DetailSection title="说明">
      <CardNotice text={dataset.description || '还没有说明。'} />
      <View style={{ gap: rpx(8) }}>
        {source ? <FactRow label="来源文件" value={source} /> : null}
        <FactRow
          label="规模"
          value={`${dataset.rowCount.toLocaleString('zh-CN')} 行 · ${
            dataset.columnCount
          } 列`}
        />
        <FactRow label="版本" value={`第 ${dataset.versionNo} 版`} />
        <FactRow
          label="上传"
          value={[dataset.ownerName, biTimeLabel(dataset.createdAt)]
            .filter(Boolean)
            .join(' · ')}
        />
        <FactRow
          label="上次使用"
          value={
            dataset.lastUsedAt ? biTimeLabel(dataset.lastUsedAt) : '还没有用过'
          }
        />
        <FactRow
          label="我的权限"
          value={
            dataset.permission === BiDatasetAccess.Manage
              ? '可管理：改名、说明、共享和删除'
              : '可使用：查看、预览和用它做图表'
          }
        />
      </View>
    </DetailSection>
  );
});
